import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import About from "../pages/about/page";
import Services from "../pages/services/page";
import ResidentialService from "../pages/services/residential/page";
import MultiFamilyService from "../pages/services/multi-family/page";
import HospitalityService from "../pages/services/hospitality/page";
import RenovationService from "../pages/services/renovation/page";
import Projects from "../pages/projects/page";
import ProjectDetail from "../pages/projects/detail/page";
import Process from "../pages/process/page";
import FAQ from "../pages/faq/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/about", element: <About /> },
  { path: "/services", element: <Services /> },
  { path: "/services/residential", element: <ResidentialService /> },
  { path: "/services/multi-family", element: <MultiFamilyService /> },
  { path: "/services/hospitality", element: <HospitalityService /> },
  { path: "/services/renovation", element: <RenovationService /> },
  { path: "/projects", element: <Projects /> },
  { path: "/projects/:id", element: <ProjectDetail /> },
  { path: "/process", element: <Process /> },
  { path: "/faq", element: <FAQ /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
